// Antd
import { Col, Row } from 'antd'
import styles from './styles.module.scss'
import SpinnerLogo from 'media/SpinerLogo'
import useGetUser from './useGetUser'

const Getting: React.FC = () => {
  const {} = useGetUser()

  return (
    <Row className={styles.loginPage}>
      <Col span={24} className="loginForm">
        <div
          className="centerItem"
          style={{ width: '100vw', height: '100vh', flexDirection: 'column' }}
        >
          <SpinnerLogo
            style={{
              transformOrigin: 'center center',
              transform: 'scale(0.7)'
            }}
          />
          <span style={{ color: '#fff' }}>Obteniendo datos del usuario.</span>
        </div>
      </Col>
    </Row>
  )
}

export default Getting
